module.exports = __webpack_public_path__ + "d9.no2.89c1703e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d9.no2.jpg
// module id = +NsR
// module chunks = 0